import React from "react";
import { Input } from "@/components/ui/input";
import { formatMoney } from "@/lib/format";

/**
 * Numeric input with a live-formatted money preview below.
 * Value is stored/emitted as a raw number (or empty string). The formatted preview
 * is display-only, e.g. "= £15.00M" beneath the input.
 * Negative numbers supported (for EBITDA etc.).
 */
export default function MoneyInput({ value, onChange, currency = "£", placeholder, testId, ...rest }) {
  const raw = value === "" || value === null || value === undefined ? "" : value;
  const numeric = Number(raw);
  const showPreview = raw !== "" && !isNaN(numeric) && numeric !== 0;

  return (
    <div>
      <Input
        type="number"
        value={raw}
        onChange={(e) => onChange && onChange(e.target.value)}
        placeholder={placeholder}
        data-testid={testId}
        {...rest}
      />
      {showPreview && (
        <div className="mt-1 text-[11px] text-muted-foreground num-display" data-testid={testId ? `${testId}-preview` : undefined}>
          = <span className="font-semibold text-emerald-700 dark:text-emerald-400">{formatMoney(numeric, currency)}</span>
        </div>
      )}
    </div>
  );
}
